import RequireAuth from "./CommonUtils/RequireAuth";
import MainDashboard from "./UnivDataComponents/MainDashboard";
import MenuBar from "./UnivDataComponents/MenuBar";
import ForgotPassword from "./ForgotPassword";
import RusaDashboard from "./UnivDataComponents/Dashboard";
import UniversityAssigningInspection from "./NocComponents/UniversityScreens/UniversityAssigningInspection";
import LaboratoriesInspection from "./NocComponents/Inspections/LaboratoriesInspection";
import StudentFacultyRatio from "./NocComponents/Inspections/StudentFacultyRatio";
import Testlogin from "./NocComponents/Testlogin";
import CheckList from "./NocComponents/Inspections/CheckList";
import ReallocatedStudents from "./NocComponents/Inspections/ReallocatedStudents";
import RecipientInstitutes from "./NocComponents/Inspections/RecipientInstitute";
import InspClosureOfInst from "./NocComponents/Inspections/InspClosureOfInst";
import InspLocationChange from "./NocComponents/Inspections/InspLocationChange";
import InspChairPersonDetails from "./NocComponents/Inspections/inspChairPersonDetails";
import CommiteRecmndations from "./NocComponents/Inspections/CommiteRecmndations";
import InspBoardOfGoverners from "./NocComponents/Inspections/InspBoardOfGoverners";
import NewCollegeRegister from "./NocComponents/NewCollegeRegister";
import IntakeVariations from "./NocComponents/Inspections/IntakeVariations";
import PreviewandPrint from "./NocComponents/PreviewandPrint";
import FinalInspection from "./NocComponents/Inspections/FinalInspection";
import InspectionDetails from "./NocComponents/Inspections/InspectionDetails";
import ScrutinyReport from "./NocComponents/ScrutinyReport";
import PaymentSuccess from "./NocComponents/PaymentSuccess";
import InspectionStatus from "./NocComponents/Inspections/InspectionStatus";
import PaymentReceipt from "./NocComponents/PaymentReceipt";
import ShiftingScrutinyReport from "./NocComponents/UniversityScreens/ShiftingScrutinyReport";
import NewCollegeApplication from "./NocComponents/NewCollegeApplication";
import ScrutinyReportForNewAc from "./NocComponents/UniversityScreens/ScrutinyReportForNewAc";
import NOCCollegeCompletionPerReport from "./NocComponents/NOCReports/NOCCollegeCompletionPerReport";
import ChangeOfManagement from "./NocComponents/UniversityScreens/ChangeOfManagement";
import ChangePassword from "./ChangePassword";
import IntakeTabs from "./NocComponents/PolyTechProgramIntake/IntakeTabs";
import PaymentForm from "./NocComponents/Payment";
import NewCollegeApplPreview from "./NocComponents/NewCollegeApplPreview";
import Grievance from "./NocComponents/Grievance";
import AdmissionResultAnalysisReport from "./NocComponents/PolyTechProgramIntake/AdmissionResultAnalysisReport";
import GrievancyReport from "./NocComponents/NOCReports/GrievancyReport";
import FinalStatus from "./NocComponents/Inspections/FinalStatus";
import DeficienciesIdentifiedService from "./NocComponents/UniversityScreens/DeficienciesIdentifiedService";
import OverallNocStatusReport from "./NocComponents/NOCReports/OverallNocStatusReport";
import DegreeUniversityDeficiencyInsp from "./NocComponents/UniversityScreens/DegreeUniversityDeficiencyInsp";
import DeficienciesIdentifiedFlow from "./NocComponents/DeficienciesIdentifiedFlow";
import DeficiencyInspectionStatus from "./NocComponents/Inspections/DeficiencyInspectionStatus";
import DeficiencyFinalStatus from "./NocComponents/Inspections/DeficiencyFinalStatus";
import PreviewsForPhaseTwo from "./NocComponents/UniversityScreens/PreviewsForPhaseTwo";
import ApplicationStatusReport from "./NocComponents/NOCReports/ApplicationStatusReport";
import Unauthorized from "./UnivDataComponents/Unauthorized";
import InspectionPhysicalStatus from "./NocComponents/UniversityScreens/InspectionPhysicalStatus";
import InspectionFinalStatus from "./NocComponents/UniversityScreens/InspectionFinalStatus";
import FirstLevelInspPreviewForShiftingPreview from "./NocComponents/UniversityScreens/FirstLevelInspPreviewForShiftingPreview";
import CommitteReport from "./NocComponents/NOCReports/CommitteReport";
// import NewConversionScrutinyReport from "./NocComponents/Inspections/NewConversionScrutinyReport";
import { Route, BrowserRouter as Router, Routes } from 'react-router-dom'
import Status from "./CommonUtils/ESIGN/Status";



const RoutesComponent = () => (
    <>
        {/* <Provider store={store}>

            <Router> */}

        <Routes>
            <Route path="/" element={<Testlogin />} />
            <Route path="/unauthorized" element={<Unauthorized />} />
            <Route path="/ForgotPassword" element={<ForgotPassword />} />
            <Route path="/NewCollegeRegister" element={<NewCollegeRegister />} />
            <Route path="/esignresponse/Status" element={<Status />} />

            {/* <Route path="/PaymentTesting" element={<PaymentTesting />} /> */}

            <Route element={<RequireAuth />}>
                <Route path="/home" element={<MenuBar><MainDashboard /></MenuBar>} />
                <Route path="/RaiseyourConcern" element={<Grievance />} />

                <Route path="/NocDashboard" element={<RusaDashboard />} />
                <Route path="/DeficienciesIdentifiedService" element={<DeficienciesIdentifiedService />} />
                <Route path="/UniversityAssigningInspection" element={<MenuBar><UniversityAssigningInspection /></MenuBar>} />
                <Route path="/ChangePassword" element={<MenuBar><ChangePassword /></MenuBar>} />
                <Route path="/StudentFacultyRatio" element={<MenuBar><StudentFacultyRatio /></MenuBar>} />
                <Route path="/CheckList" element={<MenuBar><CheckList /></MenuBar>} />
                <Route path="/InspClosureOfInst" element={<MenuBar><InspClosureOfInst /></MenuBar>} />
                <Route path="/InspLocationChange" element={<MenuBar><InspLocationChange /></MenuBar>} />
                <Route path="/inspChairPersonDetails" element={<MenuBar><InspChairPersonDetails /></MenuBar>} />
                <Route path="/InspBoardOfGoverners" element={<MenuBar><InspBoardOfGoverners /></MenuBar>} />
                <Route path="/LaboratoriesInspection" element={<MenuBar><LaboratoriesInspection /></MenuBar>} />
                <Route path="/ReallocatedStudents" element={<MenuBar><ReallocatedStudents /></MenuBar>} />
                <Route path="/RecipientInstitutes" element={<MenuBar><RecipientInstitutes /></MenuBar>} />
                <Route path="/CommiteRecmndations" element={<MenuBar><CommiteRecmndations /></MenuBar>} />
                <Route path="/IntakeVariations" element={<MenuBar><IntakeVariations /></MenuBar>} />
                <Route path="/CollegeDetails" element={<MenuBar><PreviewandPrint /></MenuBar>} />
                <Route path="/CollegeDetailss" element={<PreviewandPrint />} />


                <Route path="/InspectionDetails" element={<InspectionDetails />} />
                <Route path="/afflPaymentSucces/:id" element={<PaymentSuccess />}></Route>

                <Route path="/FinalInspection" element={<MenuBar><FinalInspection /></MenuBar>} />
                <Route path="/InspectionStatus" element={<MenuBar><InspectionStatus /></MenuBar>} />
                <Route path="/FinalStatus" element={<MenuBar><FinalStatus /></MenuBar>} />



                {/* <Route path="/ScrutinyReportExtensionPermission" element={<MenuBar><ScrutinyReportExtensionPermission /></MenuBar>} /> */}
                <Route path="/ScrutinyReport" element={<MenuBar><ScrutinyReport /></MenuBar>} />
                <Route path="/DeficienciesIdentifiedFlow" element={<MenuBar><DeficienciesIdentifiedFlow /></MenuBar>} />

                <Route path="/PaymentReceipt" element={<PaymentReceipt />}></Route>

                <Route path="/ShiftingScrutinyReport" element={<MenuBar><ShiftingScrutinyReport /></MenuBar>} />
                <Route path="/PreviewsForPhaseTwo" element={<MenuBar><PreviewsForPhaseTwo /></MenuBar>} />


                <Route path="/CollegeApplication" element={<MenuBar><NewCollegeApplication /></MenuBar>} />
                <Route path="/ScrutinyReportForNewAc" element={<MenuBar><ScrutinyReportForNewAc /></MenuBar>} />
                <Route path="/NOCCollegeCompletionPerReport" element={<MenuBar><NOCCollegeCompletionPerReport /></MenuBar>} />
                <Route path="/ChangeOfManagement" element={<MenuBar><ChangeOfManagement /></MenuBar>} />
                <Route path="/PaymentForm" element={<MenuBar><PaymentForm /></MenuBar>} />
                <Route path="/ClgApplicationPreview" element={<MenuBar><NewCollegeApplPreview /></MenuBar>} />
                <Route path="/IntakeTabs" element={<MenuBar><IntakeTabs /></MenuBar>} />
                <Route path="/RaiseyourConcernReport" element={<MenuBar><GrievancyReport /></MenuBar>} />
                {/* <Route path="/NewProgram" element={<MenuBar><NewProgram /></MenuBar>} /> */}

                <Route path="/AdmissionResultAnalysisReport" element={<MenuBar><AdmissionResultAnalysisReport /></MenuBar>} />
                <Route path="/OverallNocStatusReport" element={<MenuBar><OverallNocStatusReport /></MenuBar>} />

                <Route path="/DegreeUniversityDeficiencyInsp" element={<MenuBar><DegreeUniversityDeficiencyInsp /></MenuBar>} />
                <Route path="/DeficiencyInspectionStatus" element={<MenuBar><DeficiencyInspectionStatus /></MenuBar>} />
                <Route path="/DeficiencyFinalStatus" element={<MenuBar><DeficiencyFinalStatus /></MenuBar>} />
                <Route path="/TotalApplicationStatusReport" element={<MenuBar><ApplicationStatusReport /></MenuBar>} />
                <Route path="/InspectionPhysicalStatus" element={<MenuBar><InspectionPhysicalStatus /></MenuBar>} />
                <Route path="/InspectionFinalStatus" element={<MenuBar><InspectionFinalStatus /></MenuBar>} />
                <Route path="/CommitteReport" element={<MenuBar><CommitteReport /></MenuBar>} />
                {/* <Route path="/NewConversionScrutinyReport" element={<MenuBar><NewConversionScrutinyReport /></MenuBar>} /> */}

                <Route path="/FirstLevelInspPreviewForShiftingPreview" element={<MenuBar><FirstLevelInspPreviewForShiftingPreview /></MenuBar>} />

            </Route>


        </Routes >
        {/* </Router>
        </Provider> */}
    </>
);
export default RoutesComponent;